import React, { useState, useRef } from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { FiCopy, FiCheck, FiX } from "react-icons/fi";
import "./shareCourse.scss";

const Share = ({ handleClose, onClose, shareUrl }) => {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef(null);
  const targetUrl = shareUrl || window.location.href;
  const closeAction = handleClose || onClose;

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(targetUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      if (inputRef.current) {
        inputRef.current.select();
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    }
  };

  return (
    <OverlayContainer>
      <div className="share-overlay-backdrop" onClick={closeAction} />
      <div className="inner-share">
        {/* Close Button */}
        <button className="share-close-btn" onClick={closeAction} aria-label="Close Share Modal">
          <FiX size={18} />
        </button>

        {/* Header */}
        <div className="share-header-section">
          <h3>Share this course</h3>
          <p>Copy the link below or share directly to your favorite networks.</p>
        </div>

        {/* Copy Link Container */}
        <div className="share-link-container">
          <input
            type="text"
            value={targetUrl}
            ref={inputRef}
            readOnly
            className="share-link-input"
            onClick={(e) => e.target.select()}
          />
          <button 
            onClick={handleCopyToClipboard} 
            className={`share-copy-btn ${copied ? "copied" : ""}`}
            title="Copy to clipboard"
          >
            {copied ? (
              <>
                <FiCheck size={14} />
                <span>Copied</span>
              </>
            ) : (
              <>
                <FiCopy size={14} />
                <span>Copy</span>
              </>
            )}
          </button>
        </div>

        {/* Divider */}
        <div className="share-divider">
          <span>Or share via</span>
        </div>

        {/* Social Sharing Icons */}
        <div className="share-social-grid">
          <a
            aria-label="Share on Twitter"
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(targetUrl)}`}
            rel="noopener noreferrer"
            target="_blank"
            className="social-btn twitter"
          >
            <FaTwitter size={18} />
          </a>
          <a
            aria-label="Share on Facebook"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(targetUrl)}`}
            rel="noopener noreferrer"
            target="_blank"
            className="social-btn facebook"
          >
            <FaFacebookF size={18} />
          </a>
          <a
            aria-label="Share on LinkedIn"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(targetUrl)}`}
            rel="noopener noreferrer"
            target="_blank"
            className="social-btn linkedin"
          >
            <FaLinkedinIn size={18} />
          </a>
          <a
            aria-label="Share on WhatsApp"
            href={`https://api.whatsapp.com/send?text=${encodeURIComponent(targetUrl)}`}
            rel="noopener noreferrer"
            target="_blank"
            className="social-btn whatsapp"
          >
            <FaWhatsapp size={18} />
          </a>
          <a
            aria-label="Share by Email"
            href={`mailto:?subject=yslearn Course&body=Check out this course: ${encodeURIComponent(targetUrl)}`}
            rel="noopener noreferrer"
            target="_blank"
            className="social-btn email"
          >
            <FaEnvelope size={18} />
          </a>
        </div>
      </div>
    </OverlayContainer>
  );
};

export default Share;
